__turbopack_context__.v({
  "body": "FireflyTranslateDialog-module__07DK1W__body",
  "infoText": "FireflyTranslateDialog-module__07DK1W__infoText",
  "languageList": "FireflyTranslateDialog-module__07DK1W__languageList",
  "languageRow": "FireflyTranslateDialog-module__07DK1W__languageRow",
  "searchGroup": "FireflyTranslateDialog-module__07DK1W__searchGroup",
});
